const styles = () => ({
  navbarIconButton: { marginRight: 2 },
});
export default styles;
